import http from 'plugins/axios';

export default {
  getTickers() {
    return http.post({
      url: '/admin/mytoken/searchTickers'
    });
  }
};
